// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.7
//   protoc               v5.29.6
// source: common.proto

export const protobufPackage = 'compasspb';

/** Sort to be used by search APIs for specifying sorting */
export enum Sort {
  /** SORT_NONE - default */
  SORT_NONE = 0,
  SORT_ASC = 1,
  SORT_DESC = 2,
}

/** Error genric error type for most APIs */
export interface Error {
  /** Primary error message (backwards compatible) */
  message?: string | undefined;
  /** Additional error details as BSON document */
  details?: { [key: string]: any } | undefined;
}
